module.exports = __webpack_public_path__ + "assets/img/user_achievement_l4.0bda1c8f.png";